// Centralised GA4 event tracking so every feature/button reports under one
// consistent event name with parameters, instead of a unique event per element.
// Card dropdown ids carry a "-home" suffix only for the pre-signup landing page
// preview card; stripping it keeps usage comparable across both contexts.
const LANDING_SUFFIX = "-home";

const FEATURE_ID_MAP = {
  "match-summary": "predicted_lineups",
  "head-to-head": "head_to_head",
  "recent-form": "recent_form",
  "recent-cup-form": "recent_cup_form",
  "team-stats": "team_stats",
  "match-predictions": "match_predictions",
  "cards-fouls": "cards_fouls",
};

// Normalises a raw DOM element id (which may be per-view, e.g. "head-to-head-home")
// into a stable feature_id plus the card context it came from.
export function resolveCardFeature(rawId) {
  if (!rawId) {
    return null;
  }
  const isLanding = rawId.endsWith(LANDING_SUFFIX);
  const baseId = isLanding ? rawId.slice(0, -LANDING_SUFFIX.length) : rawId;
  return {
    featureId: FEATURE_ID_MAP[baseId] || baseId,
    cardContext: isLanding ? "landing_page" : "app",
  };
}

export function trackFeature(featureId, featureCategory, extraParams = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("event", "feature_click", {
    feature_id: featureId,
    feature_category: featureCategory,
    event_category: "engagement",
    event_label: featureId,
    ...extraParams,
  });
}
